import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const getSingleLanguageFunc = createAsyncThunk(
  "get single language function",
  async (id, thunkAPI) => {
    try {
      const response = await api.get(`dashboard/languages/${id}`);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const getSingleLanguageSlicer = createSlice({
  name: "get single language slicer",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSingleLanguageFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getSingleLanguageFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSingleLanguageFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getSingleLanguageSlicer.reducer;
